import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';

@Injectable()
export class CustomErrorHandlerService implements ErrorHandler {
  private errorWrapper = inject<{ error: Error }>('ERROR_WRAPPER' as never, { optional: true });
  private injector = inject(Injector);

  handleError(error: Error) {
    if (error instanceof HttpErrorResponse) {
      error = new Error(error.message);
    }

    console.error(error);
    // eslint-disable-next-line no-debugger
    debugger;

    if (this.errorWrapper) {
      this.errorWrapper.error = error;
    } else {
      import('./services/sentry.service').then(({ SentryService }) => {
        const service = this.injector.get(SentryService);
        service?.captureException(error);
      });
    }
  }
}
